// extracted by mini-css-extract-plugin
export default {"nft-card":"Card_nft-card__kgj-w","img":"Card_img__yH4pf","text":"Card_text__hsWvW"};